/*eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import CardListA from 'components/CardList/CardListA';
import CardListD from 'components/CardList/CardListD';
import { SearchContextProvider } from 'contexts/SearchContext';
import { PaginationContextProvider } from 'contexts/PaginationContext';

const CardListContainer = ({ withSearch = true, ...props }) => {
  const CardListComponent = withSearch ? CardListA : CardListD;
  return (
    <>
      <SearchContextProvider>
        <PaginationContextProvider>
          <CardListComponent {...props} />
        </PaginationContextProvider>
      </SearchContextProvider>
    </>
  );
};

CardListContainer.propTypes = {
  items: PropTypes.array, // items in list
  itemIncrement: PropTypes.number, // number of items to display at a time
  divided: PropTypes.bool, // divider lines between items
  withSearch: PropTypes.bool, // should we display the search input
  queryData: PropTypes.object, // data that was used to filter the widget
  displayOptions: PropTypes.object, // data that is used to customize labels
};

export default CardListContainer;
